<!--在线学习-->
<template>
  <div class="el-OnlineLearning">
    <el-row class="page_content" ref="page_content">
      <h1 :class="{ head_title: true, isScrollTop }">
        在线学习
        <!-- <small
          style="
            color: #eee;
            font-size: 0.5em;
            font-weight: lighter;
            margin-left: 1em;
          "
          >所有课程</small> -->
      </h1>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
        v-if="!$strExistHostnameOnce(['localhost','lfjtysxx'])"
      >
        <el-tab-pane label="当前学期" name="first">
          <!-- <span class="colorRed">推荐使用Google浏览器，360或搜狗浏览器极速模式学习，学习前请仔细阅读注意事项！</span> -->
          <el-row style="height: calc(100% - 63px)" class="curriculum">
            <courseList
              v-if="activeName == 'first'"
              :list="[]"
              :semesterType="1"
            ></courseList>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="所有学期" name="second" v-if="$gradeNotShow(['hbafajj'])">
          <!-- <span class="colorRed">推荐使用Google浏览器，360或搜狗浏览器极速模式学习，学期前请仔细阅读注意事项！</span> -->
          <el-row style="height: calc(100% - 63px)" class="curriculum">
            <courseList
              v-if="activeName == 'second'"
              :list="[]"
              :semesterType="2"
            ></courseList>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <template v-else>
          <courseListLfjtysxx
            :list="[]"
            :semesterType="2"
          ></courseListLfjtysxx>
      </template>
      <!-- <main v-else private="河北建筑工程" class="school_hbjz" ref="school_hbjz">
        <el-row style="height: calc(100% - 63px)" :class="{ curriculum: true }">
          <courseListHbjz />
        </el-row>
      </main> -->
    </el-row>

    <!-- 提示有 -->
    <el-dialog
      title="系统提醒"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :show-close="false"
      width="500px"
      class="newIndex"
    >
      <div>
        <h1 style="font-size: 1.5rem">您还有课程未选：</h1>
        <p style="text-indent: 2em; font-size: 1.3rem">
          需选课程数：<span style="color: #409eff; font-weight: bold">{{
            courseSelectionInfo.requiredNum
          }}</span>
        </p>
        <p style="text-indent: 2em; font-size: 1.3rem">
          已选课程数：<span style="color: #409eff; font-weight: bold">{{
            courseSelectionInfo.selectedNum
          }}</span>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goCourseSelection">去选课</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getQueryVariable,
  getStudentInfoKeyForRoleTag,
  openWithRoleTag,
} from "../../common/ulit";
import courseList from "@/components/courseList"; //学期课程
import courseListHbjz from "@/components/courseList_hbjz"; //【河北建筑工程】学期课程
import courseListLfjtysxx from "@/components/courseListLfjtysxx"; //【廊坊交通运输学校】学期课程
export default {
  name: "OnlineLearning",
  components: {
    courseList: courseList,
    courseListHbjz, //【河北建筑工程】
    courseListLfjtysxx, //【廊坊交通运输学校】
  },
  data() {
    return {
      isScrollTop: true,
      tableData: [], //当前学期List
      allTableData: [], //所有学期List
      activeName: "first",
      currentPage1: 1,
      total: 0,
      allCurrentPage1: 1,
      allTotal: 0,
      onShow: 0,
      limit: 4,
      page: 1,
      limit1: 10,
      getNowTime: "",
      dialogVisible: false,
      courseSelectionInfo: {
        //选课信息
        needElectiveCourse: false, // false(不需要选课了)  true（仍需选课）
        selectedNum: 0, //已选数量
        requiredNum: 0, //需选数量
      },
    };
  },
  computed: {
    getPayConfig() {
      return this.$store.getters.getPayConfig;
    },
  },
  created() {
    // this.getLeaningCenterList();
    this.getNowDate();
    this.getElectiveRequire();
  },
  mounted() {
    const dom = this.$refs.page_content.$el;
    dom.onscroll = (e) => (this.isScrollTop = e.target.scrollTop <= 200);
  },
  methods: {
    validate_canIn(eventType) {
      //没有缴费是否允许进行下一步操作
      const fieldMap = {
        videoStudy: "canStudy",
        taskList: "canWork",
        examList: "canExam",
        makeUpExamList: "canRepealExam",
      };
      const config = this.getPayConfig;
      const canIn = config[fieldMap[eventType]];
      if (canIn === false) {
        this.$message({
          type: "warning",
          message: "您未缴费，无法操作！",
        });
        return false;
      } else {
        return true;
      }
    },
    handleClick(tab, event) {
      // this.currentPage1 = 1;
      // this.allCurrentPage1 = 1;
      // this.getLeaningCenterList();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getLeaningCenterList();
    },
    startLearning(item) {
      //学习
      if (false === this.validate_canIn("videoStudy")) return;
      let infoTime1Str = item.infoTime1Str; //学习时间
      let startDate = infoTime1Str.split(" 至 ")[0]; //开始时间
      let endDate = infoTime1Str.split(" 至 ")[1]; //结束时间
      const date = this.getNowTime; //当前时间
      // const date = "2022-12-10 00:20:20"; //当前时间
      if (this.$compareTime(date, startDate)) {
        this.$message({
          message: "学习时间还未开始",
          type: "error",
        });
        return;
      }
      if (this.$compareTime(endDate, date)) {
        this.$message({
          message: "学习时间已结束",
          type: "error",
        });
        return;
      }
      openWithRoleTag(
        window.location.origin +
          "/StartLearning?tePlanCourseId=" +
          item.tePlanCourseId +
          "&courseName=" +
          this.$Base64.encode(item.courseName)
      );

      // if(!this.$isEmpty(item.courseUrl)){
      //   window.open(item.courseUrl);
      // }else{
      //   window.open(window.location.origin + '/StartLearning?tePlanCourseId='+item.tePlanCourseId);
      // }
    },
    schoolAssignment(item) {
      //作业
      if (false === this.validate_canIn("taskList")) return;
      let infoTime3Str = item.infoTime3Str; //作业时间
      let startDate = infoTime3Str.split(" 至 ")[0]; //开始时间
      let endDate = infoTime3Str.split(" 至 ")[1]; //结束时间
      const date = this.getNowTime; //当前时间
      // const date = "2022-12-10 00:20:20"; //当前时间
      if (this.$compareTime(date, startDate)) {
        this.$message({
          message: "作业时间还未开始",
          type: "error",
        });
        return;
      }
      if (this.$compareTime(endDate, date)) {
        this.$message({
          message: "作业时间已结束",
          type: "error",
        });
        return;
      }
      openWithRoleTag(
        window.location.origin +
          "/SchoolAssignment?tePlanCourseId=" +
          item.tePlanCourseId +
          "&courseName=" +
          this.$Base64.encode(item.courseName)
      );
    },
    examList(item) {
      //考试
      if (false === this.validate_canIn("examList")) return;

      let infoTime4Str = item.infoTime4Str; //考试时间
      let startDate = infoTime4Str.split(" 至 ")[0]; //开始时间
      let endDate = infoTime4Str.split(" 至 ")[1]; //结束时间
      const date = this.getNowTime; //当前时间
      // const date = "2022-12-10 00:20:20"; //当前时间
      if (this.$compareTime(date, startDate)) {
        this.$message({
          message: "考试时间还未开始",
          type: "error",
        });
        return;
      }
      if (this.$compareTime(endDate, date)) {
        this.$message({
          message: "考试时间已结束",
          type: "error",
        });
        return;
      }
      openWithRoleTag(
        window.location.origin +
          "/ExamList?tePlanCourseId=" +
          item.tePlanCourseId +
          "&courseName=" +
          this.$Base64.encode(item.courseName)
      );
    },
    putQuestions(item) {
      //提问
      openWithRoleTag(
        window.location.origin +
          "/PutQuestions?tePlanCourseId=" +
          item.tePlanCourseId +
          "&courseName=" +
          this.$Base64.encode(item.courseName)
      );
    },
    getLeaningCenterList() {
      //获取学习中心 列表
      let param = {};
      /**2023-07-26 修改隐藏提问按钮 当前学期去掉分页，邯郸学院已经部署  shi*/
      if (this.activeName == "first") {
        param = {
          limit: this.limit1,
          page: this.page,
          semesterType: this.activeName == "first" ? 1 : 2,
        };
      } else {
        param = {
          limit: this.limit,
          page: this.page,
          semesterType: this.activeName == "first" ? 1 : 2,
        };
      }

      this.$store.dispatch("user/getLeaningCenterList", param).then((ret) => {
        if (ret.code === 0 || ret.code === "0") {
          if (this.activeName == "first") {
            this.tableData = ret.data;
            this.total = ret.count;
            sessionStorage.setItem(
              getStudentInfoKeyForRoleTag() + "_onlineLearningRows",
              JSON.stringify(ret.data)
            );
          } else {
            this.allTableData = ret.data;
            this.allTotal = ret.count;
            sessionStorage.setItem(
              getStudentInfoKeyForRoleTag() + "_onlineLearningAllRows",
              JSON.stringify(ret.data)
            );
          }
        } else {
          this.$message({
            message: ret.msg,
            type: "warning",
          });
        }
      });
    },
    getNowDate() {
      const this_ = this;
      this.$store
        .dispatch("getNowTime")
        .then((res) => {
          if (res.code == 0) {
            this.getNowTime = res.data;
          } else {
            this.getNowTime = this.$getNewDate();
          }
        })
        .catch(function (error) {
          this_.getNowTime = this_.$getNewDate();
        });
    },
    makeUpExamList(item) {
      if (false === this.validate_canIn("canRepealExam")) return;
      let infoTime4Str = item["makeUpExamTimeInfo"]; //考试时间
      let startDate = infoTime4Str.split(" 至 ")[0]; //开始时间
      let endDate = infoTime4Str.split(" 至 ")[1]; //结束时间
      const date = this.getNowTime; //当前时间
      if (this.$compareTime(date, startDate)) {
        this.$message({
          message: "补考时间还未开始",
          type: "error",
        });
        return;
      }
      if (this.$compareTime(endDate, date)) {
        console.log("endDate=" + endDate);
        console.log("date=" + date);
        this.$message({
          message: "补考时间已结束",
          type: "error",
        });
        return;
      }
      openWithRoleTag(
        window.location.origin +
          "/MakeUpExamList?tePlanCourseId=" +
          item.tePlanCourseId +
          "&courseName=" +
          this.$Base64.encode(item.courseName)
      );
    },
    getElectiveRequire() {
      //是否完成选课
      this.$store.dispatch("user/getElectiveRequire").then((ret) => {
        if (ret.code === 0 || ret.code === "0") {
          this.courseSelectionInfo = ret.data;
          if (ret.data.needElectiveCourse) {
            //needElectiveCourse: false(不需要选课了)  true（仍需选课）
            this.dialogVisible = true;
          }
        } else {
          this.$message.warning(ret.msg);
        }
      });
    },
    goCourseSelection() {
      //去选课
      this.$router.push({ name: "CourseSelectionCenter" });
    },
  },
};
</script>
<style lang="less">
@import "../../styles/base.less";

.el-OnlineLearning {
  .page_content {
    height: calc(100vh - 80px);
    position: relative;
    .head_title {
      position: sticky;
      top: 0;
      z-index: 2;
      transition: 0.3s ease;
      filter: blur(2px);
      &.isScrollTop {
        filter: blur(0);
      }
    }
  }
  .wd {
    color: @red;
  }
  .el-tabs__header {
    margin-bottom: 5px;
  }
  .el-dialog__body {
    border-top: 1px solid #ebeef5;
  }

  .el-link.el-link--primary {
    padding: 0 20px;
  }

  .el-tabs__item {
    font-size: 20px;
  }
  .classCourseNatureConcat {
    font-size: 12px;
    background-color: #73a1f7;
    color: white;
    padding: 4px 8px 3px;
    margin-left: 10px;
    border-radius: 30px;
    font-weight: 100;
  }
  //   针对【河北建筑工程】=>
  .page_content {
    .school_hbjz {
    }
  }
  //   <=针对【河北建筑工程】
}
</style>



// WEBPACK FOOTER //
// src/pages/learningCenter/OnlineLearning.vue